import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8a63536&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../css/list.scss?vue&type=style&index=0&id=f8a63536&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=f8a63536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a63536",
  null
  
)

export default component.exports